// A copy of Harbor's item id rule, in
// packages/integrations/harbor/shared/src/item-id.ts. Change both or neither.

// An item's id has to be safe wherever it's used as a name: as a command-line
// argument, where a leading hyphen would read as a flag, inside Terraform
// names and custom role ids, and as a segment of a secret's name. It holds no
// `_`, so the `_` after it ends its segment of a Google secret's name, and a
// prefix condition for one site can't match another's secrets.
const ITEM_ID_PATTERN = /^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;

// The length of a DNS label. It leaves room for what a generated name puts
// around the id.
const ITEM_ID_MAX_LENGTH = 63;

export const INVALID_ITEM_ID = `Use lowercase letters, digits and hyphens, starting and ending with a letter or digit, up to ${ITEM_ID_MAX_LENGTH} characters.`;

/** Whether `id` can be the id of a Jira (AI) connector, site or pool account
 * item. It's checked as it stands: an id isn't trimmed. */
export const isItemId = (id: unknown): id is string =>
  typeof id === "string" &&
  id.length <= ITEM_ID_MAX_LENGTH &&
  ITEM_ID_PATTERN.test(id);

// A site's custom role ids in its vault project carry its id, between
// `p0JiraAi_` and `_create`, and Google caps a role id at 64 characters.
export const SITE_ID_MAX_LENGTH = 48;

export const INVALID_SITE_ID = `Use lowercase letters, digits and hyphens, starting and ending with a letter or digit, up to ${SITE_ID_MAX_LENGTH} characters.`;

/** Whether `id` can be the id of a site item, whose custom role ids carry
 * it. */
export const isSiteId = (id: unknown): id is string =>
  isItemId(id) && id.length <= SITE_ID_MAX_LENGTH;
